import React from 'react';


import NotFound from './NotFound';


const is404 = (error) =>
  error &&
  ((error.status && error.status === 404) ||
    (error.response && is404(error.response)));

const Generic = ({ error }) => {

  if (is404(error)) return <NotFound />;
  return (
  <div>An error occurred, unable to load page.</div>
  );
};

export default Generic;
